import { HttpClient } from './serviceBase';
import { utils } from '../utils/utils'

class PaymentService {
    Get = async (planId) =>
        await HttpClient.Get(`/api/plans/${planId}`);

    GetBankPlan = async (planId, bankId) =>
        await HttpClient.Get(`/api/plans/${planId}/bank/${bankId}`);

    //PaymentCard
    SearchCards = async (filters) =>
        await HttpClient.Post(`/api/PaymentCard/search`, filters);

    GetCardById = async (cardId) =>
        await HttpClient.Get(`/api/PaymentCard/${cardId}`);

    GetTotalsCards = async (cashRegisterId, filters) =>
        await HttpClient.Post(`/api/PaymentCard/${cashRegisterId}/totalsCards`, filters);

    GetTotalsCardById = async (cashRegisterId, cardId) =>
        await HttpClient.Get(`/api/PaymentCard/${cashRegisterId}/totalsCards/${cardId}`);
    
    GetBin = async (binNumber, country) =>
        await HttpClient.Get(`/api/PaymentCard/bins/${binNumber}/${country}`);
    
    GetBanks = async (pageSize, pageNumber, filters) => {
        const queryString = utils.GetQueryStringsFromObject({
            ...filters,
            pageSize,
            pageNumber
        })
        return await HttpClient.Get(`/api/PaymentCard/banks?${queryString}`);
    }

    GetPlansByCardAndBankId = async (bankId, cardId) =>
        await HttpClient.Get(`/api/PaymentCard/${bankId}/plans/${cardId}`);

    GetPlansByCardId = async (cardId) =>
        await HttpClient.Get(`/api/PaymentCard/plansByCard/${cardId}`);

    GetAllCardsByBankId = async (bankId) =>
        await HttpClient.Get(`/api/PaymentCard/bank/${bankId}`);

    GetChecks = async (filters) => {
        const queryString = utils.GetQueryStringsFromObject(filters);
        return await HttpClient.Get(`/api/checks?${queryString}`);
    }
}

export default new PaymentService();